import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'inputValue',
		'inputDisplayHours',
		'inputDisplayMinutes',
	]

	static values = {
		'stepSize': { type: Number, default: 5 }
	}

	connect() {
	}

	inputDisplayChanged(event) {
		const hours    = this.getIntegerOrDefault(this.inputDisplayHoursTarget.value, 0)
		const minutes  = this.getIntegerOrDefault(this.inputDisplayMinutesTarget.value, 0)
		const newValue = (hours * 60) + minutes
		this.inputValueTarget.value = newValue
		this.updateDisplayTargets()
		this.inputValueTarget.dispatchEvent(new Event('change'))
	}

	increment(event) {
		const currentStringValue = this.inputValueTarget.value
		const currentValue = this.getIntegerOrDefault(currentStringValue, 30)
		const newValue = currentValue + this.stepSizeValue
		this.inputValueTarget.value = newValue
		this.updateDisplayTargets()
		this.inputValueTarget.dispatchEvent(new Event('change'))
	}

	decrement(event) {
		const currentStringValue = this.inputValueTarget.value
		const currentValue = this.getIntegerOrDefault(currentStringValue, 30)
		let newValue = currentValue - this.stepSizeValue
		if (newValue < 0) newValue = 0
		this.inputValueTarget.value = newValue
		this.updateDisplayTargets()
		this.inputValueTarget.dispatchEvent(new Event('change'))
	}

	updateDisplayTargets() {
		let hours, minutes
		[hours, minutes] = this.getHoursAndMinutes(this.inputValueTarget.value)
		this.inputDisplayHoursTarget.value = hours
		this.inputDisplayMinutesTarget.value = minutes
	}

	getIntegerOrDefault(stringValue, defaultValue) {
		let intValue = parseInt(stringValue)
		if (Number.isNaN(intValue)) intValue = defaultValue
		if (intValue < 0) intValue = 0
		return intValue
	}

	getHoursAndMinutes(minutes) {
		let hours, minutesRemainder
		hours = Math.floor(minutes / 60)
		minutes = minutes % 60
		return [hours, minutes]
	}
}

